import React from 'react';

import { Colors } from '@zapier/theme';

import {
  EVENT_TRACK_TRIAL_BANNER,
  Price,
  useNextPlan,
} from '@zapier/design-system-revenue';

import LinkContainer from 'app/common/components/LinkContainer';

type ProfessionalTrialBannerProps = {
  trialDays: number;
};

export const ProfessionalTrialBanner = ({
  trialDays,
}: ProfessionalTrialBannerProps) => {
  const { isLoading: isLoadingNextPlan, nextPlan } = useNextPlan();

  if (trialDays > 30) {
    return <div>You have {trialDays} days left in your extended trial.</div>;
  }

  const nextPlanAmount =
    nextPlan?.intervals?.find(interval => interval.interval === 'year')
      ?.monthlyAmount ?? -1;

  return isLoadingNextPlan ? (
    /**
     * We need to render these divs while plan details are loading in order to
     * avoid content jumping in the top bar.
     */
    <div></div>
  ) : (
    <span id="trial-message">
      <span style={{ fontWeight: 600 }}>
        Yay! You are now trialing Professional.
      </span>{' '}
      You have {trialDays} days to try out our{' '}
      <LinkContainer
        href="/help/account/billing-pricing/understand-your-zapier-premium-trial"
        style={{
          color: Colors.deepSpace,
        }}
        trackData={{
          in_trial: true,
        }}
        trackMessage={EVENT_TRACK_TRIAL_BANNER}
      >
        premium features
      </LinkContainer>{' '}
      or{' '}
      <LinkContainer
        href={`/app/billing/plans/upgrade/free/${nextPlan?.name}?interval=year`}
        style={{
          color: Colors.blue700,
          textDecoration: 'none',
        }}
        trackData={{
          in_trial: true,
        }}
        trackMessage={EVENT_TRACK_TRIAL_BANNER}
      >
        upgrade now
      </LinkContainer>
      {nextPlanAmount > -1 && (
        <span>
          {' '}
          for just <Price>{nextPlanAmount}</Price>/month.
        </span>
      )}
    </span>
  );
};
